import { useAtomValue } from 'jotai'
import React from 'react'
import { match } from 'ts-pattern'

import { dialogInfoAtom } from '../atoms'

import { AddAllowedDomainDialog } from './AddAllowedDomainDialog'
import { DeleteAllowedDomainDialog } from './DeleteAllowedDomainDialog'

export const Dialogs = () => {
  const dialogInfo = useAtomValue(dialogInfoAtom)

  return match(dialogInfo?.dialogType)
    .with(undefined, () => null)
    .with('add', () => <AddAllowedDomainDialog />)
    .with('delete', () => <DeleteAllowedDomainDialog />)
    .exhaustive()
}
